export {NavigationTable} from "./navigation-table";
export type {NavigationTableProps, NavigationTableItem} from "./navigation-table";
